export default {
  agency_key: '',
  mode: '',
  chat_url: '',
  beian: '',
  beian_gn: '',

  address: '',
  uc_host: 'https://user.800pr.com',
  site_host: 'https://www.800pr.com',
  special_url: '/',
  site_title: '新闻街',
  welcome_title: '新闻街',
  site_short_title: '新闻街',
  site_subtitle: '新闻街',
  company_name: '北京世纪一诺文化传媒有限公司',
  copyright: '© 2026 新闻街',
  logo: 'https://fagao.oss-cn-shanghai.aliyuncs.com/alioss/190/260625/bb15bb5179ca76b170b39a4b781cc23b.png',
  favicon: 'https://fagao.oss-cn-shanghai.aliyuncs.com/alioss/190/260625/deed690082a223b741af677f294a1eb0.jpg',
  payment: '',
  qq: '',
  tel: '13522465482',
  company_account_id: '0200 2528 0920 0008 397',
  company_bank: '工商银行北京八里庄北里支行',
  company_bank_name: '北京世纪一诺文化传媒有限公司',
  alipay_account_id: '',
  alipay_name: '',
  alipay_pic: 'https://fagao.oss-cn-shanghai.aliyuncs.com/alioss/190/260703/263067da3c8aad7e48879bc0c6cbbec7.webp',
  wechat_pic: 'https://fagao.oss-cn-shanghai.aliyuncs.com/alioss/190/260703/263067da3c8aad7e48879bc0c6cbbec7.webp',
  section_id: 5384639,
  belonger_id: 5384639,
}



//////////////////
// WEBPACK FOOTER
// ./project_config.js
// module id = null
// module chunks = 